import { api } from "@//api";
import { queryClient } from "@/queryClient";

export const checkInBooking = async (id: string) => {
  const resp = await api.put(`/bookings/${id}/check-in`);
  queryClient.invalidateQueries(["bookings"]);
  queryClient.invalidateQueries(["messages"]);
  return resp;
};
